import type { WidgetEnvironmentExtended } from './sgwt-widgets-utils';

export const LATEST_SG_BOOTSTRAP_VERSION = '5.50.0';

export type SgBootstrapTheme = 'standard' | 'dark';

// 'system' means use the environment system configuration.
export type SgBootstrapThemeExtended = 'standard' | 'dark' | 'system';

const SG_CONNECT_HOM = 'https://sgconnect-hom.fr.world.socgen/sgconnect';
const SG_CONNECT_PRD = 'https://sso.sgmarkets.com/sgconnect';

export const SG_CONNECT_ENDPOINTS: Record<WidgetEnvironmentExtended, string> = {
  development: SG_CONNECT_HOM,
  homologation: SG_CONNECT_HOM,
  internal_homologation: SG_CONNECT_HOM,
  internal_production: SG_CONNECT_PRD,
  production: SG_CONNECT_PRD,
};

// Possible values for Production environment
export const PRODUCTION_ENVIRONMENTS = ['production', 'prod', 'prd'];

export const WidgetNames = ['sgwt-account-center', 'sgwt-connect', 'sgwt-help-center', 'sgwt-mini-footer', 'sgwt-splash-screen'] as const;
export type WidgetName = (typeof WidgetNames)[number];

export const SupportedLanguages = ['fr', 'en', 'cs', 'de', 'es', 'it', 'ja', 'pt', 'ru', 'zh'] as const;
export type SupportedLanguage = (typeof SupportedLanguages)[number];

export const PANEL_EXPANDED_PROPERTY = 'sgwt-help-center.expanded';
